import React from 'react'
import Config from "../../../config/Config";
import { formatSalaryRange, getSalaryDisplay } from '../utils'
import "./job.scss";
let filePath = Config.getFilePath();

class jobCard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }
  async componentDidMount() {

  }

  onCheck = (value) => {
    this.props.onCheck(value);
  }

  info = (data) => {
    const { history } = this.props;
    history.push({ pathname: "/home/jobdetails", state: { data } })

  }



  render() {
    const { data, value, width } = this.props;
    let SAL = formatSalaryRange(data?.SALFROM, data?.SALTO);

    let SALFROM = SAL[0];
    let SALTO = SAL[1];
    // data:数据
    return <div component-data="jobCard">
      <div className={data?.id === value ? `job_items` : `job_item`} onClick={() => { value ? this.onCheck(data?.id) : this.info(data) }} style={{ width: width }}>

        <div className='job_info'>
          <div className='sf-page-tool-between'>
            <div className='job_name'>
              <div className='job_JOBNAME' title={data?.JOBNAME}>{data.JOBNAME}</div>
              {
                data.IMPORTANCE === '2' ?
                  <img className='job_jz' src={require("../../../img/pinzhunzhun/dataSource/jz.png")} /> : ""
              }
            </div>
            <div className='job_SAL'>
              {getSalaryDisplay(SALFROM, SALTO)}
              {data.SALPAY == "11" ? "元/小时" : ""}
              {data.SALPAY == "12" ? "元/天" : ""}
              {data.SALPAY == "13" ? "元/周" : ""}
            </div>
          </div>

          <div className='requireTag_box'>
            {data?.DISTRICT_CN ? <label>{data.DISTRICT_CN}</label> : ""}
            {data.REQWE_CN ? <label>{data.REQWE_CN}</label> : ""}
            {data.REQEDU_CN ? <label >{data.REQEDU_CN}</label> : ""}
            {data.REQSEX_CN ? <label >{data.REQSEX_CN}</label> : ""}

          </div>
        </div>

        <div className='job_ent'>
          <div style={{ display: "flex" }}>
            <img className='job_logo' src={data?.ENTLOGO ? filePath + 'enterprise/M' + data.enterprise_id + '.png' : require('../../../img/pinzhunzhun/dataSource/ent_logo.png')} />
            <div className='job_entName'>{data?.ENTNAME}</div>
          </div>

          <div>{data?.DISTRICT_CN}</div>



        </div>
      </div>

    </div>
  }
}

export default jobCard;